import { fetchLatestAppVersionForAppId } from '@utils/apps';

export function generateInsertSSOUrl (origUrl, insertBackendDomainName) {
    if (!insertBackendDomainName) {
        return;
    }

    const mobileCookie = getMobileCookie();

    if (insertBackendDomainName.includes('insert.io')) {
        const baseUrl = `https://${insertBackendDomainName}/v1/auth/ssoLogin?insertUrl=${encodeURIComponent(origUrl)}`;

        if (mobileCookie !== 'undefined') {
            return `${baseUrl}&ssoToken=${mobileCookie}`;
        }

        return baseUrl;
    }

    return `https://${insertBackendDomainName}${origUrl}`;
}

export function generateFeedbackSSOUrl (path = '', hosts) {
    if (hosts && hosts.feedback) {
        return `https://${hosts.feedback}${path}`;
    }

}

export function getMobileCookie () {
    const cookie = {};
    document.cookie.split(';').forEach((el) => {
        // eslint-disable-next-line id-length
        const [k, v] = el.split('=');
        cookie[k.trim()] = v;
    });

    return encodeURIComponent(cookie['pendo.sess.mobile']);
}

export async function getInsertAppTabUrl (tabName, appId, from, insertBackendDomainName) {
    const baseSettingsUrl = '/#/main/apps/settings/';
    const fromPrefix = from ? `?from=${from}` : '';
    let settingsUrl;
    let out;

    switch (tabName) {
        case 'sdk':
        case 'details':
            settingsUrl = `${baseSettingsUrl}${appId}/${tabName}${fromPrefix}`;
            out = generateInsertSSOUrl(settingsUrl, insertBackendDomainName);
            break;
        case 'screens':
            // eslint-disable-next-line no-case-declarations
            const latestAppVersion = await fetchLatestAppVersionForAppId(appId);
            settingsUrl = `${baseSettingsUrl}${appId}/version/${latestAppVersion.id}/screens${fromPrefix}`;
            out = generateInsertSSOUrl(settingsUrl, insertBackendDomainName);
            break;
        default:
            out = null;
    }

    return out;
}
